import styled from 'styled-components';

export const ADD_TAG_WIDTH = 4.8;
export const TAG_INNER_HORIZONTAL_PADDING = 0.8;

export const Strip = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0.8rem 1.6rem;

  &:not(:last-child) {
    border-bottom: 0.1rem solid var(--color-stroke-default);
  }

  &[data-header='true'] {
    background: var(--color-surface-secondary);
    border: none;
  }
`;

export const Left = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  & > div:last-child {
    margin-inline-end: 0.4rem;
    margin-inline-start: 0.8rem;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.8rem;

  &[data-full-width='true'] {
    flex: 1;
  }
`;

export const TagLabel = styled.div<TagProps>`
  display: flex;
  white-space: nowrap;
  padding: 0.4rem ${TAG_INNER_HORIZONTAL_PADDING}rem;
  border: 0.1rem solid;
  border-color: ${({ color }) => color || 'var(--content-border-color)'};
  border-radius: 10rem;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  font-size: 1.2rem;
  font-weight: 400;
  color: var(--color-grayscale-white);
  min-width: auto;
  background-color: var(--app-background);
  max-width: 100%;

  > span {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover,
  &:focus {
    cursor: pointer;
    background-color: ${({ color }) => `${color}20` || `rgba(250, 250, 250, 0.2)`};
  }

  &:last-child {
    min-width: ${ADD_TAG_WIDTH}rem;

    &:hover,
    &:focus {
      cursor: pointer;

      svg {
        color: var(--color-grayscale-white);
      }
    }
  }
`;

type TagProps = {
  color?: string;
};

export const Point = styled.div<TagProps>`
  background-color: ${({ color }) => color || 'var(--content-border-color)'};
  height: 0.8rem;
  width: 0.8rem;
  min-width: 0.8rem;
  border-radius: 50%;
`;
